import { Title } from "../../../../../components/Title";
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const ConfirmTitle = () => <Title title='Confirm'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>